export default "__VITE_ASSET__f976e863__"